import useIsAvailabilityPermitted from "PFApp/use_is_availability_permitted";
import { activityPermissions, isUserSeniorPartnerOrResourcer } from "PFCore/helpers/templates";
import { useCustomTypes } from "PFCore/helpers/use_custom_types";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";

const useWorkflowPermissions = () => {
  const { data: currentProfile } = useCurrentProfile();
  const { customTypes } = useCustomTypes();

  const isAvailabilityPermitted = useIsAvailabilityPermitted();

  // Engagementes allows ["ro", "rw"] permissions
  const engagementMatchesPermissions = ["rw", "ro"].includes(
    activityPermissions(currentProfile?.permissions_group, currentProfile?.templates, "engagement")
  );
  // Roles allows only ["ro", "rw"] permissions
  const rolesMatchesPermissions = ["ro", "rw"].includes(
    activityPermissions(currentProfile?.permissions_group, currentProfile?.templates, "role")
  );

  const isSPorR = isUserSeniorPartnerOrResourcer(currentProfile?.permissions_group);

  const isEngagementEnabled = engagementMatchesPermissions && isSPorR;
  const isRoleEnabled = rolesMatchesPermissions && isSPorR;
  const isPlannerEnabled =
    isAvailabilityPermitted &&
    customTypes.filter((customType) =>
      customType.sections.find((section) => section.key === "filters_planner")
    ).length > 0 &&
    isSPorR;

  return { isEngagementEnabled, isRoleEnabled, isPlannerEnabled };
};

export default useWorkflowPermissions;
